import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, DialogContentText } from '@material-ui/core';

const ModalComponent = (props) => {

    return (
        <div>
            <Dialog
                open={props.show}
                onClose={props.handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">{props.title}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description" style={{ color: 'black' }}>
                        {props.msg}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={props.handleBtn1} style={{ color: 'grey', outline: 'none', ...props.btn1Style }} >
                        {props.btn1Text}
                    </Button>
                    <Button variant="contained" color="primary" onClick={props.handleBtn2} style={{ ...props.btn2Style }} >
                        {props.btn2Text}
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
};

export default ModalComponent;